import React, {createContext, useContext} from "react";
import PropTypes from "prop-types";
import {io} from "socket.io-client";

import {getApiBase} from "../utils/apiBase.js";

const socket = io(getApiBase(), {
  autoConnect: false,
  transports: ["websocket", "polling"]
});

const SocketContext = createContext(socket);

const SocketProvider = ({children}) => (
  <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
);

SocketProvider.propTypes = {
  children: PropTypes.node.isRequired
};

const useSocket = () => useContext(SocketContext);

export {SocketContext, useSocket};
export default SocketProvider;
